<template>
    <!-- <transition :name="transName"> -->
    <transition name="fade" mode="out-in">
        <slot/>
    </transition>
</template>

<script>
export default {
    name: 'TransitionPage',
}
</script>

<style lang="scss" scoped>

// ROUTER TRANSITION -- FADE
.fade- {
    &enter-active, &leave-active {
        transition: opacity 0.3s ease-in-out;
    }
    // &enter-active {
    //     transition-delay: 0.3s;
    // }
    &enter, &leave-to {
        opacity: 0;  
    }
}

// // ROUTER TRANSITION -- SLIDE FADE

// .slide-fade- {
//     &enter {
//         transform: translateX(100vw);
//     }
//     &enter-active {
//         transition: all .6s ease;
//     }
//     &leave-active {
//         transition: all 0s linear 0.6s;
//         transform: translateX(0);
//     }
// }

</style>
